import React, { FunctionComponent } from "react"

interface FlagIconProps {}

const FlagIcon: FunctionComponent<FlagIconProps> = () => {
  return (
    <svg
      width="54"
      height="57"
      viewBox="0 0 54 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_721_566)">
        <path
          d="M13.9707 41.6667C14.5136 41.6667 14.975 41.4738 15.355 41.088C15.7459 40.7022 15.9414 40.2282 15.9414 39.666V30.8697C16.1911 30.8036 16.5928 30.7044 17.1466 30.5721C17.7003 30.4398 18.3735 30.3737 19.1661 30.3737C20.6102 30.3737 21.9729 30.528 23.2541 30.8367C24.5461 31.1453 25.8111 31.498 27.0489 31.8949C28.2975 32.2917 29.5679 32.6444 30.8599 32.9531C32.152 33.2617 33.5147 33.416 34.9479 33.416C35.7622 33.416 36.4788 33.3774 37.0977 33.3003C37.7166 33.2121 38.2704 33.0964 38.759 32.9531C39.2476 32.7987 39.709 32.6169 40.1433 32.4074C40.7622 32.1208 41.2237 31.7019 41.5277 31.1508C41.8426 30.5997 42 29.9328 42 29.1501V13.1614C42 12.4669 41.7828 11.9048 41.3485 11.4749C40.9251 11.045 40.3713 10.83 39.6873 10.83C39.1335 10.83 38.4767 10.9237 37.7166 11.1111C36.9674 11.2875 36.0065 11.3757 34.8339 11.3757C33.4441 11.3757 32.1086 11.2214 30.8274 10.9127C29.5461 10.6041 28.2758 10.2513 27.0163 9.85451C25.7568 9.44666 24.4756 9.09393 23.1726 8.79631C21.8697 8.48766 20.4962 8.33334 19.0521 8.33334C18.2704 8.33334 17.5809 8.37192 16.9837 8.44908C16.3865 8.52624 15.8436 8.64199 15.355 8.79631C14.8664 8.95063 14.3779 9.13802 13.8893 9.35848C13.2921 9.64507 12.8252 10.0143 12.4886 10.4663C12.1629 10.9182 12 11.519 12 12.2685V39.666C12 40.2172 12.19 40.6856 12.57 41.0714C12.9609 41.4683 13.4278 41.6667 13.9707 41.6667Z"
          fill="#05AAFF"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_721_566"
          x="-4.66667"
          y="-3.33333"
          width="63.3333"
          height="63.3333"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.66667"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_721_566"
          />
          <feOffset dy="3.33333" />
          <feGaussianBlur stdDeviation="6.66667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0196078 0 0 0 0 0.666667 0 0 0 0 1 0 0 0 0.32 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_721_566"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_721_566"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default FlagIcon
